import Calendario from "./Calendario.js";
import Graficos from "./Graficos.js";
import Matematica from "./Matematica.js";
import Objetos from "./Objetos.js";
import Texto from "./Texto.js";
import Tipos from "./Tipos.js";
import Util from "./Util.js";

export const portugolLibs = /* javascript */ `{
  Calendario: ${Calendario},
  Graficos: ${Graficos},
  Matematica: ${Matematica},
  Objetos: ${Objetos},
  Texto: ${Texto},
  Tipos: ${Tipos},
  Util: ${Util},
}`;
